import React from 'react'

export const WorkbenchTrackingContext = React.createContext<{ scene?: string }>(
  {},
)

WorkbenchTrackingContext.displayName = 'WorkbenchTrackingContext'
